import React from "react";
import "./BodyFrame.css";

interface Props {
  children: React.ReactNode;
}

function BodyFrame({ children }: Props) {
  return (
    <div className="body-frame-outer">
      <div className="body-frame-inner">
          {children}
      </div>
    </div>
  );
}

export default BodyFrame;
